import { axios } from '@/services/axios';

const getPartnerDataStorageLocations = async (partnerId) => {
    const res = await axios.get(
        `/Partner/${partnerId}/DataStorageLocations/Available`,
        {
            headers: {
                'X-RequestScope': 40,
            },
        },
    );
    return res.data;
};

export default getPartnerDataStorageLocations;
